import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  Date,
  ScheduleFrequency,
} from "../../../services/cloudchipr.api";
import { getScheduleNestRunDatesFixedCacheKey } from "../../../components/pages/schedule/classic/components/create/tabs/utils/constants";
import { formatDate } from "../../../utils/helpers/date-time/datetime-format";
import { getCronFrequency } from "../../../components/pages/schedule/common/utils/helpers/cron/getCronFrequency";

interface GetScheduleNextRunDatesThunkArgs {
  startDate: Date;
  endDate?: Date | null;
  cron: string;
  timeZone: string;
  frequency?: ScheduleFrequency;
  interval?: number;
}

export const getScheduleNextRunDatesThunk = createAsyncThunk(
  "schedules/getScheduleNextRunDatesThunkArgs",
  async (
    {
      startDate,
      cron,
      frequency,
      interval,
      endDate,
      timeZone,
    }: GetScheduleNextRunDatesThunkArgs,
    { dispatch },
  ) => {
    const { postUsersMeSchedulesNextRunDate } = cloudChiprApi.endpoints;

    await dispatch(
      postUsersMeSchedulesNextRunDate.initiate(
        {
          body: {
            cron,
            time_zone: timeZone,
            end_date_time: endDate,
            schedule_frequency: frequency,
            schedule_interval: interval,
            start_date_time: startDate ? formatDate(startDate) : null,
          },
        },
        {
          fixedCacheKey: getScheduleNestRunDatesFixedCacheKey(
            getCronFrequency(cron),
          ),
        },
      ),
    ).unwrap();
  },
);
